import React, { forwardRef } from "react";
import classnames from "classnames";

import { InputBase, InputBaseProps } from "@material-ui/core";

import { BiSearch } from "react-icons/bi";

import { useSearchInputStyles } from "./SearchInput.styles";

interface IProps extends InputBaseProps {
  className?: string;
}

const SearchInput = forwardRef<HTMLInputElement, IProps>((props, ref) => {
  const { className, ...restProps } = props;

  const classes = useSearchInputStyles();

  return (
    <InputBase
      fullWidth
      ref={ref}
      type="search"
      startAdornment={<BiSearch size={22} className={classes.icon} />}
      className={classnames(classes.root, className)}
      classes={{
        input: classes.input
      }}
      {...restProps}
    />
  );
});

SearchInput.displayName = "SearchInput";

export default SearchInput;
